import React, {Component} from 'react'
import {DatePicker, Form, message, Popconfirm, Spin} from "antd";
import "./route.less"
import "./route-line.less"
import {subStr, subTimeStr} from "../../utills/subStringUtill";
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
const EditableContext = React.createContext();
class RouteStepView  extends Component {

    constructor(props, context) {
        super(props, context);
        this.state={
            nodes:[],
            editingIndex:-1,
            routeName:"",
            routeType:'O',
            readOnly:true,
            nodeDt:"",
        }
    }


    save=(id,nodeDt)=>{
        this.setState({
            loading:true,
        })
        let result = ajax(baseUrl+'/api/v1/p/mms/kt/orderNode',{id:id,nodeDt:nodeDt},"PUT");
        result.then((resp)=>{
            if(resp.code === 200){
                message.info("更新成功")
                if(this.props.reload){
                    this.props.reload()
                }
            }else{
                message.error(resp.message)
                let newNodes = [...this.state.nodes]
                for(let item of newNodes){
                    if(item.id === id){
                        item.nodeDt = item.oldDt
                        break
                    }
                }
                this.setState({
                    nodes:newNodes
                })
                this.setState({
                })
            }
        }).catch(()=>{
            this.setState({
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    componentDidMount() {

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.nodes!=this.state.nodes) {
            this.setState({
                nodes: nextProps.nodes
            })
        }
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <EditableContext.Provider value={this.props.form}>
                <div className='order-info box-shadow padding-20'>
                    <div className={"routeBox processShow"}>
                        <Spin spinning={this.props.loading}>
                            {this.state.nodes.map((node,index)=>{
                                return (
                                    <div className={this.props.routeType+""==="I"?'routeIteamLine finish':'routeIteamLine finish'} >
                                        <Popconfirm placement="top"
                                                    title={<div><p>请选择日期</p><p>
                                                        <DatePicker
                                                            showTime
                                                            value={node.nodeDt?moment(node.nodeDt, 'YYYY-MM-DD HH:mm:ss'):null}
                                                            onChange={(date,dateStr)=>{
                                                                let newNodes = [...this.state.nodes]
                                                                for(let item of newNodes){
                                                                    if(item.id === node.id){
                                                                        item.oldDt = item.nodeDt
                                                                        item.nodeDt = dateStr
                                                                        break
                                                                    }
                                                                }
                                                                this.setState({
                                                                    nodes:newNodes
                                                                })
                                                            }}
                                                            format="YYYY-MM-DD HH:mm:ss"/>
                                                    </p></div>}
                                                    okText="保存"
                                                    cancelText="取消"
                                                    disabled={this.props.readOnly}
                                                    onCancel={(() => {})}
                                                    onConfirm={()=>{
                                                        if(node.nodeDt!==undefined&&node.nodeDt!==""){this.save(node.id,node.nodeDt)}
                                                    }}>
                                            <div className={this.props.readOnly?'info':'info itemHover'}>
                                                <div className="circle"><i></i></div>
                                                <div className="title">{node.node}</div>
                                                <div className="time1">{node.nodeDt? subStr(node.nodeDt) :''}</div>
                                                <div className="time2">{node.nodeDt? subTimeStr(node.nodeDt) :''}</div>
                                            </div>
                                        </Popconfirm>
                                    </div>
                                )
                            })}
                        </Spin>
                    </div>
                </div>
            </EditableContext.Provider>
        );
    }
}
const RouteStepViewForm = Form.create()(RouteStepView)
export default RouteStepViewForm